module.exports = __webpack_public_path__ + "static/media/gateway-icon.985baad7.svg";